import React from 'react';

import { IconType } from 'components/Icon/constants';
import { Title } from 'components/Toolbar/constants';
import Control from 'components/Toolbar/Controls/Control';
import { ControlState } from 'components/Toolbar/Controls/Control/constants';
import Dropdown from 'components/Toolbar/Dropdowns/TextLineHeight';
import { useControlWithDropdown } from 'components/Toolbar/hooks';
import * as Constants from 'const';
import * as Models from 'models';

type Props = {
  blockLineHeight: Constants.TextLineHeightValue | undefined;
  setLineHeight(type: Constants.TextLineHeightValue): void;
  controlState?: Models.ControlState;
  dataTestId?: string;
};

const TextLineHeight: React.FunctionComponent<Props> = (props) => {
  const { setLineHeight, blockLineHeight, controlState = ControlState, dataTestId = 'textLineHeight' } = props;
  const { control, isOpen, state, toggleDropdown } = useControlWithDropdown({ controlState });

  return (
    <Control
      controlState={controlState}
      onToggle={toggleDropdown}
      ref={control}
      state={state}
      title={Title.LINE_HEIGHT}
      type={IconType.LINE_HEIGHT_CONTROL}
      dataTestId={`${dataTestId}-control`}
    >
      {isOpen && <Dropdown blockLineHeight={blockLineHeight} setLineHeight={setLineHeight} dataTestId={`${dataTestId}-control`} />}
    </Control>
  );
};

export default TextLineHeight;
